import I18N from '@leverege/i18n';
import GeoJsonPointer from "./GeoJsonPointer.js";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.imagine.map.InstallGeoJsonPointerAction');
const create = opts => {
  const {
    relationship,
    name
  } = opts;
  const {
    blueprint,
    path
  } = relationship;
  return {
    id: `blueprint.action.${path}.InstallGeoJsonPointer`,
    name: tf('name', {
      name: name || blueprint.name
    }),
    handles: cxt => {
      const can = cxt?.clientProps?.delegate?.canCreate();
      return can === true;
    },
    appearance: () => {
      return {
        name: t('name', {
          name: name || blueprint.name
        }),
        icon: tIcon('icon', 'fa fa-plus fa-fw')
      };
    },
    perform: ({
      context
    }) => {
      const {
        mapViewer,
        clientProps: {
          delegate,
          relationship
        }
      } = context;
      if (mapViewer == null || delegate == null || relationship == null) {
        return;
      }
      mapViewer.setPointer(new GeoJsonPointer({
        ...opts,
        map: mapViewer.map,
        relationship,
        delegate
      }));
    }
  };
};
export default {
  create
};